"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeolocationGoogleMapsHelper = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var GeolocationGoogleMapsHelper = /*#__PURE__*/function () {
  function GeolocationGoogleMapsHelper() {
    (0, _classCallCheck2.default)(this, GeolocationGoogleMapsHelper);
  }

  (0, _createClass2.default)(GeolocationGoogleMapsHelper, [{
    key: "shouldLoadMapsSdk",
    value: function shouldLoadMapsSdk(googleMapsKey) {
      if (!googleMapsKey) return false;
      return !window.google || !window.google.maps;
    }
  }, {
    key: "loadMapsSdk",
    value: function loadMapsSdk(googleMapsKey) {
      window.google = window.google || {};
      window.google.maps = {};
      window.google.maps.loadPromise = new Promise(function (resolve) {
        window.google.maps.onLoad = resolve;
      });
      var script = document.createElement("script");
      script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(googleMapsKey, "&libraries=places");
      document.head.appendChild(script);
      script.onload = window.google.maps.onLoad;
    }
  }, {
    key: "registerAddressSearch",
    value: function () {
      var _registerAddressSearch = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(selector, onPlaceChange) {
        var search;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!window.google || !window.google.maps)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return this.loadPromise;

              case 4:
                search = document.getElementById(selector);

                if (search) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                this._addressSearch = new window.google.maps.places.Autocomplete(search);

                this._addressSearch.addListener("place_changed", onPlaceChange);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function registerAddressSearch(_x, _x2) {
        return _registerAddressSearch.apply(this, arguments);
      }

      return registerAddressSearch;
    }()
  }, {
    key: "loadPromise",
    get: function get() {
      if (!window.google || !window.google.maps) return new Promise(function (resolve) {
        return setImmediate(resolve);
      });
      return window.google.maps.loadPromise || new Promise(function (resolve) {
        return setImmediate(resolve);
      });
    }
  }, {
    key: "addressSearch",
    get: function get() {
      return this._addressSearch;
    }
  }]);
  return GeolocationGoogleMapsHelper;
}();

exports.GeolocationGoogleMapsHelper = GeolocationGoogleMapsHelper;